export default __webpack_public_path__ + "static/media/5712.e97ffc83.jpg";